/* EdgePro mobile sticky buy bar: shows once the real buy button leaves the
   viewport, hides again when it returns. The bar's button submits the real
   product form. Bar markup renders in main-product.liquid. */
(function () {
  var bar = document.querySelector('[data-ep-sticky-buy]');
  if (!bar || !('IntersectionObserver' in window)) return;
  var sectionId = bar.getAttribute('data-section-id');
  var realBtn = document.getElementById('ProductSubmitButton-' + sectionId);
  if (!realBtn) return;

  var observer = new IntersectionObserver(
    function (entries) {
      bar.classList.toggle('ep-sticky-buy--visible', !entries[0].isIntersecting);
    },
    { rootMargin: '0px 0px -10% 0px' }
  );
  observer.observe(realBtn);

  var barBtn = bar.querySelector('[data-ep-sticky-submit]');
  if (barBtn) {
    barBtn.addEventListener('click', function () {
      realBtn.click();
    });
  }
})();
